// ANCHOR Website Mock Data - Private Members' Work Club

export const brandData = {
  name: "ANCHOR",
  title: "A Private Members' Work Club",
  supportingLine: "15 independent private work suites in the Golden Triangle.",
  qualifierLine: "Membership-based. Limited. By application."
};

// What ANCHOR Is
export const whatAnchorIs = {
  title: "What ANCHOR Is",
  copy: "ANCHOR is a private members' work club for professionals who need a place outside the home, without noise, formality, or shared offices.",
  secondaryCopy: "Membership provides access to a dedicated private suite within a calm, shared environment.",
  bullets: [
    "15 independent private work suites",
    "Membership with minimum term",
    "Fully serviced, utilities included"
  ]
};

// The Suites
export const suitesData = {
  title: "The Suites",
  intro: "Each member uses a fully independent private suite for full working days.",
  bullets: [
    "Private bathroom with shower in every suite",
    "Kitchenette in every suite",
    "Independent access",
    "Climate control (heating & cooling)",
    "Natural light",
    "Private terrace area",
    "Fully furnished"
  ]
};

// Shared Spaces
export const sharedSpacesData = {
  title: "Shared Spaces",
  intro: "Shared spaces support the working day without turning the club into a social or leisure venue.",
  bullets: [
    "Outdoor pool and lounge areas",
    "Covered outdoor gym",
    "Outdoor kitchen and long communal table",
    "Rooftop terrace",
    "On-site parking",
    "Conference Room"
  ],
  closingLine: "All shared spaces are intended for quiet, respectful use."
};

// Location
export const locationData = {
  title: "Golden Triangle Location",
  copy: "Located between Quinta do Lago and Vilamoura. Near Cabana Sass' and BJ's Oceanside, a short walk from the beach.",
  smallLine: "",
  image: "https://customer-assets-lqy194kg.emergentagent.net/job_73135e9b-537d-46be-aefa-96084daa0b74/artifacts/04c02ce1763935b2_anchor-dining-1320x1510.jpg"
};

// Membership
export const membershipData = {
  title: "Membership",
  copy: "Membership at ANCHOR is limited and subject to approval. Suites are licensed for professional use with a minimum term.",
  disclaimer: "This is not a public workspace.",
  cta: "By Invitation Only"
};

// Images
export const heroImages = {
  main: "https://customer-assets-lqy194kg.emergentagent.net/job_73135e9b-537d-46be-aefa-96084daa0b74/artifacts/n9acv9vv_Delia-8.webp",
  workspace: "https://customer-assets-lqy194kg.emergentagent.net/job_73135e9b-537d-46be-aefa-96084daa0b74/artifacts/1kvwedy4_Delia-199.webp",
  community: "https://customer-assets.emergentagent.com/job_algarve-cowork/artifacts/9cjrc04i_IMG-20250728-WA0042.jpg",
  poolside: "https://customer-assets-lqy194kg.emergentagent.net/job_73135e9b-537d-46be-aefa-96084daa0b74/artifacts/x2507ui6_Delia-16.webp"
};

// Navigation
export const navLinks = [
  { label: "About", href: "#what-anchor-is" },
  { label: "Suites", href: "#suites" },
  { label: "Shared Spaces", href: "#shared-spaces" },
  { label: "Location", href: "#location" },
  { label: "Membership", href: "#membership" }
];
